import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
import { createPatientTransferLogger } from '../../../../account/sidebar/patient-transfer/logger';
export default class PatientTransferCompletedTrack extends AbstractTrack {
    /* @ngInject */
    constructor($injector) {
        super($injector);
        this.$injector = $injector;
        this.eventNameSegment = 'Patient Transfer Completed';
        this.logger = createPatientTransferLogger(this.stateWatcher);
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.PATIENT_TRANSFER.COMPLETED, ($e, context) => {
            this.logger?.info('Patient transfer completed', {
                transfer_id: context.transfer_id,
                event_span: 'patient_transfer_transferred',
            });
            this.trackSegment(context, true);
        });
    }
}
